import React from 'react';
import { Grid } from '@material-ui/core';
import { Survey } from '@klp/survey/index';
import { KommentarerView } from '@klp/kommentarer/index';
import { FrontpageTitle } from '../components/FrontpageTitle';
import { FremhevdeKommentarer } from '@klp/kommentarer/components/FremhevdeKommentarer';
import FrontpageCards from '../components/FrontpageCards';
import ForvaltningsplanSummary from '@klp/forvaltningsplan/components/ForvaltningsplanSummary';

export const FrontpageForBygg = () => {
    return (
        <Grid container={true} spacing={2}>
            <Grid item={true} xs={12} sm={6} md={8} lg={9}>
                <Survey />
                <KommentarerView />
                <FrontpageTitle />
                <FremhevdeKommentarer />
                <FrontpageCards />
            </Grid>
            <Grid item={true} xs={12} sm={6} md={4} lg={3}>
                <ForvaltningsplanSummary />
            </Grid>
        </Grid>
    );
};
